import type { XRSupport } from './types.js';

// `navigator.xr.isSessionSupported` returns Promise<boolean>. We swallow
// per-call rejects (security policy / iframe sandboxed without
// allow="xr-spatial-tracking") and treat them as "unsupported" — the
// modal then shows the fallback message.
async function safeIsSupported(mode: XRSessionMode): Promise<boolean> {
  if (typeof navigator === 'undefined' || navigator.xr === undefined) return false;
  try {
    return await navigator.xr.isSessionSupported(mode);
  } catch {
    return false;
  }
}

export async function detectXRSupport(): Promise<XRSupport> {
  if (typeof navigator === 'undefined' || navigator.xr === undefined) {
    return { hasWebXR: false, vrSupported: false, arSupported: false };
  }
  const [vrSupported, arSupported] = await Promise.all([
    safeIsSupported('immersive-vr'),
    safeIsSupported('immersive-ar'),
  ]);
  return { hasWebXR: true, vrSupported, arSupported };
}
